import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { TextField, Button, InputLabel, FormControl, Select, Grid } from '@material-ui/core';
import { isMobile, useMobileOrientation } from 'react-device-detect';
import { setNpiInfo, setData } from '../../../redux/dataSlice';
import { baseApiUrl } from '../../../config';

const NpiLookupComponent = (props) => {
  const [knowsNPI, setKnowsNPI] = React.useState(null);
  const [lookupFields, setLookupFields] = React.useState({});
  const [formErrors, setFormErrors] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [nppesHcpList, setNppesHcps] = React.useState(null);
  const [hlxHcps, setHlxHcps] = React.useState(null);

  const { isPortrait } = useMobileOrientation();

  const isMobilePortrait = React.useMemo(() => {
    return isMobile && isPortrait;
  }, [isPortrait]);

  React.useEffect(() => {
    if (_.isBoolean(knowsNPI)) {
      const lookupFields = document.getElementById('lookup-fields');
      // eslint-disable-next-line no-unused-expressions
      lookupFields?.scrollIntoView();
    }
  }, [knowsNPI]);

  const updateLookupFields = (field) => {
    return (event) => {
      setLookupFields({ ...lookupFields, [field]: event.target.value });
    };
  };

  const validateNpi = (value) => {
    return /^\d+$/.test(value) && value.length === 10;
  };

  if (props.isLicensed === null) {
    return (
      <div
        style={{
          marginTop: 50,
          marginLeft: !isMobilePortrait && 50
        }}
      >
        <p>Are you a Licensed Healthcare Provider (prescriber with NPI number)?</p>
        <div style={{ display: 'flex' }}>
          <Button
            variant="contained"
            className="hlx-button"
            onClick={() => props.setData({ isLicensed: true })}
          >
            Yes
          </Button>
          <Button
            variant="contained"
            className="hlx-button"
            onClick={() => {
              props.setData({ isLicensed: false, npiInfo: {} });
            }}
          >
            No
          </Button>
        </div>
      </div>
    );
  }

  const lookupHcp = async () => {
    const isValid = validateFields();
    const baseUrl = `${baseApiUrl}/api/npilookup?`;
    const params = Object.keys(_.pickBy(lookupFields, _.identity))
      .map((key) => key + '=' + lookupFields[key].trim())
      .join('&');

    // console.log(`${baseUrl}${params}`);

    if (isValid) {
      setFormErrors({});
      setLoading(true);
      const req = fetch(`${baseUrl}${params}`);
      req.then((response) => {
        response.json().then((json) => {
          setNppesHcps(json.registryHcps.results);
          setHlxHcps(json.hlxHcps);
          setLoading(false);
          const hcpListElem = document.getElementById('npi-lookup-results');
          // eslint-disable-next-line no-unused-expressions
          hcpListElem?.scrollIntoView();
        });
      });
      req.catch((err) => {
        console.log('err on getting api is', err);
        setLoading(false);
      });
    }
  };

  const validateFields = () => {
    const errors = {};
    if (knowsNPI && !validateNpi(lookupFields.number)) {
      errors.number = true;
    } else if (!knowsNPI) {
      ['first_name', 'last_name', 'state'].forEach((field) => {
        if (!lookupFields[field]) {
          errors[field] = true;
        }
      });
    }
    setFormErrors(errors);
    return _.isEmpty(errors);
  };

  const renderNextButton = () => {
    return (
      <Button
        variant="contained"
        className="hlx-button"
        style={{ width: 250 }}
        onClick={() => {
          props.setData({ isLicensed: true, npiInfo: {} });
        }}
      >
        Continue to Registration Form
      </Button>
    );
  };

  const renderNppesAddress = (addresses) => {
    return (
      <>
        {addresses[0].address_1}
        {addresses[0].address_1 && <br />}
        {`${addresses[0].city} ${addresses[0].state}`}
      </>
    );
  };

  const renderHlxAddress = (hcp) => {
    return (
      <>
        {hcp.orgname}
        {hcp.orgaddress1 && <br />}
        {`${hcp.orgcity} ${hcp.orgstate}`}
      </>
    );
  };

  const renderHlxHcps = () => {
    if (_.isArray(hlxHcps) && hlxHcps.length > 0) {
      return (
        <div>
          <div style={{ marginBottom: 10 }}>
            Click Select next to the record that lists your information:
          </div>
          {
            <Grid container spacing={3} gutter={3} justify={'space-between'}>
              {hlxHcps.map((hcp, hcpIdx) => {
                return (
                  <Grid item container xs={12} key={hcpIdx}>
                    <Grid item xs={3} sm={3} className="flex vertical-center">
                      <Button
                        className="hlx-button select-hcp-button"
                        variant="contained"
                        onClick={() => props.setNpiInfo(hcp)}
                      >
                        Select
                      </Button>
                    </Grid>
                    <Grid item xs={5} sm={3} className="flex vertical-center">
                      {hcp.npinumber}
                      {hcp.npinumber && <br />}
                      {`${hcp.firstname} ${hcp.middleinitial || ''} ${hcp.lastname}`}
                      {isMobilePortrait && (
                        <>
                          <br />
                          {renderHlxAddress(hcp)}
                        </>
                      )}
                    </Grid>
                    {!isMobilePortrait && (
                      <Grid item xs={3} className="flex vertical-center">
                        {renderHlxAddress(hcp)}
                      </Grid>
                    )}

                    <Grid
                      item
                      xs={4}
                      sm={3}
                      className="flex vertical-center"
                      style={{ paddingLeft: 20 }}
                    >
                      {`${hcp.orgstate} ${hcp.statelicensenum || ''}`}
                      <br />
                      {hcp.specialty}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          }
        </div>
      );
    }
  };

  const renderNppesHcps = () => {
    if (nppesHcpList && !nppesHcpList.length && hlxHcps && !hlxHcps.length) {
      return (
        <div>
          <div>None found.</div>
          <br />
          <br />
          {renderNextButton()}
        </div>
      );
    }
    if (_.isArray(nppesHcpList)) {
      return (
        <div>
          <div style={{ marginBottom: 10 }}>
            {!_.isArray(hlxHcps) || !hlxHcps.length
              ? 'Click Select next to the record that lists your information:'
              : nppesHcpList.length
              ? 'NPPES Registry records:'
              : ''}
          </div>
          <Grid container spacing={3} gutter={3} justify={'space-between'}>
            {nppesHcpList.map((hcp, hcpIdx) => {
              const { basic, addresses, taxonomies } = hcp;
              return (
                <Grid item container xs={12} key={hcpIdx}>
                  <Grid item xs={3} sm={3} className="flex vertical-center">
                    <Button
                      className="hlx-button select-hcp-button"
                      variant="contained"
                      onClick={() => props.setNpiInfo(hcp)}
                    >
                      Select
                    </Button>
                  </Grid>
                  <Grid item xs={5} sm={3} className="flex vertical-center">
                    {hcp.number}
                    {hcp.number && <br />}
                    {`${basic.first_name} ${basic.middle_name || ''} ${basic.last_name}`}
                    {isMobilePortrait && (
                      <>
                        <br />
                        {renderNppesAddress(addresses)}
                      </>
                    )}
                  </Grid>
                  {!isMobilePortrait && (
                    <Grid item xs={3} className="flex vertical-center">
                      {renderNppesAddress(addresses)}
                    </Grid>
                  )}

                  <Grid item xs={4} sm={3} className="flex vertical-center">
                    {taxonomies[0].state ||
                      (taxonomies[0].license && (
                        <>{`${taxonomies[0].state || ''} ${taxonomies[0].license || ''}`}</>
                      ))}
                    <br />
                    {taxonomies[0].desc}
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
          <div style={{ marginTop: 50, marginBottom: 20 }}>If you do not see your record</div>
          {renderNextButton()}
        </div>
      );
    }
  };

  const renderSearchButton = () => {
    if (loading) {
      return <p>loading...</p>;
    }
    return (
      <Button
        variant="contained"
        className="hlx-button"
        style={{ cursor: 'pointer' }}
        onClick={lookupHcp}
      >
        Search
      </Button>
    );
  };

  const renderNpiLookupFields = () => {
    if (knowsNPI !== null) {
      if (knowsNPI) {
        return (
          <div style={{ display: 'flex', flexDirection: 'column', padding: 10 }}>
            <TextField
              fullWidth
              style={{ marginBottom: 20, marginTop: 0 }}
              value={lookupFields.number || ''}
              onChange={updateLookupFields('number')}
              label={'*NPI'}
              error={formErrors.number}
              margin={'dense'}
              variant={'outlined'}
              type="number"
              helperText={formErrors['number'] && 'Invalid NPI'}
            />
            {renderSearchButton()}
          </div>
        );
      }

      return (
        <div style={{ display: 'flex', flexDirection: 'column', padding: 10 }}>
          <TextField
            fullWidth
            style={{ marginBottom: 20, marginTop: 0 }}
            value={lookupFields.first_name || ''}
            onChange={updateLookupFields('first_name')}
            error={formErrors.first_name}
            label={'*First Name'}
            margin={'dense'}
            variant={'outlined'}
          />
          <TextField
            fullWidth
            style={{ marginBottom: 20, marginTop: 0 }}
            value={lookupFields.last_name || ''}
            onChange={updateLookupFields('last_name')}
            error={formErrors.last_name}
            label={'*Last Name'}
            margin={'dense'}
            variant={'outlined'}
          />
          <div style={{ display: 'flex', marginBottom: 20 }}>
            <div style={{ paddingRight: 5, flex: 3 }}>
              <TextField
                fullWidth
                value={lookupFields.city || ''}
                onChange={updateLookupFields('city')}
                label={'City'}
                margin={'dense'}
                style={{ margin: 0 }}
                variant={'outlined'}
                inputProps={{
                  autoComplete: 'off'
                }}
              />
            </div>
            <div style={{ paddingLeft: 5, flex: '1 100px' }}>
              <FormControl fullWidth>
                <InputLabel error={formErrors.state} htmlFor="state">
                  *State
                </InputLabel>
                <Select
                  native
                  variant={'outlined'}
                  value={lookupFields.state}
                  onChange={updateLookupFields('state')}
                  error={formErrors.state}
                  margin={'dense'}
                  style={{ margin: 0 }}
                  label="*State"
                  inputProps={{
                    name: 'state',
                    id: 'state'
                  }}
                >
                  {_.map(_.map(props.dropDownValues.states), (state) => {
                    return (
                      <option key={state.abrv} value={state.abrv}>
                        {state.name}
                      </option>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
          </div>

          {renderSearchButton()}
        </div>
      );
    }
  };

  const resetState = (knowsNpi, cancelButton = false) => {
    setKnowsNPI(knowsNpi);
    setLookupFields({});
    setNppesHcps(null);
    setHlxHcps(null);
    setFormErrors({});
    setLoading(false);

    if (cancelButton) {
      props.setData({ isLicensed: null });
    }
  };

  return (
    <div className="npi-lookup-component">
      <div className="npi-lookup-btns">
        <Button variant="contained" className="hlx-button" onClick={() => resetState(true)}>
          I know my NPI Number
        </Button>
        <Button variant="contained" className="hlx-button" onClick={() => resetState(false)}>
          Look up my NPI Number
        </Button>
        <Button
          className="cancel-btn hlx-button"
          variant="contained"
          onClick={() => resetState(null, true)}
        >
          Cancel
        </Button>
      </div>
      <div className="npi-lookup-fields" id="lookup-fields">
        {renderNpiLookupFields()}
      </div>
      <div id="npi-lookup-results">
        <div style={{ marginBottom: 20 }}>{renderHlxHcps()}</div>
        <div>{renderNppesHcps()}</div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ data }) => {
  const { meetingInfo, isLicensed, dropDownValues } = data;
  return { meetingInfo, isLicensed, dropDownValues };
};

export default connect(mapStateToProps, { setNpiInfo, setData })(NpiLookupComponent);
